import { Instance, SnapshotIn, types } from 'mobx-state-tree';
import {
  UserRole,
  TeammateStatus,
  TeammateStatuses,
  UserRoles,
} from 'globals/types';

export interface SingleTeammateProps {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  role: UserRole;
  statusType: TeammateStatus;
  date: number;
  invitedBy?: string;
}

export const SingleTeammate = types.model({
  id: types.number,
  firstName: types.string,
  lastName: types.string,
  email: types.string,
  phone: types.maybe(types.string),
  role: types.optional(types.enumeration(UserRoles), UserRole.USER),
  statusType: types.optional(
    types.enumeration(TeammateStatuses),
    TeammateStatus.INACTIVE
  ),
  date: types.number,
  invitedBy: types.maybe(types.string),
});

export type SingleTeammateSnapshot = SnapshotIn<typeof SingleTeammate>;
export type SingleTeammateInstance = Instance<typeof SingleTeammate>;
